import MaskedInput from 'react-text-mask';
import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

export const MASKED_PHONE_CHARS = /[()\s-]/g;
export const SSN_CHARS = /[\D]/g;
export const NON_NUMERIC = /[\D]/g;

export function PhoneMaskedTextInput(props) {
  const { inputRef, mask, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholder=""
    />
  );
}

export function SsnMaskedTextInput(props) {
  const { inputRef, mask, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholder=""
    />
  );
}

export function DollarNumberFormatUsd(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      decimalScale={0}
      prefix="$"
    />
  );
}

DollarNumberFormatUsd.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default {
  SsnMaskedTextInput,
  PhoneMaskedTextInput,
  DollarNumberFormatUsd,
};
